import Vue from "vue";
let actions = {
  quickLinksNewDashboard(context) {
    context.commit("addLog", { request: "quickLinksNewDashboard" });
    Vue.axios
      .get(`${process.env.SERVICES_BASE_URL}/billPayments/v5/servicesList.json`)
      .then(response => {
        context.commit(
          "setQuickLinksNewDashboard",
          response.data.inAppServicesList
        );
        context.commit("setBbpsImages", response.data.bbpsImages);
        context.commit("removeLog", { request: "quickLinksNewDashboard" });
      })
      .catch(() => {
        context.commit("removeLog", { request: "quickLinksNewDashboard" });
      });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/quickLinksNewDashboard/actions.js